import { IconName } from "@deligoo/ui/src/icons/build"

import { Client } from "@/types"

export namespace ClientUtils {
  export function getIconForLocationType(locationType: Client["location_type"] | "cluster"): IconName {
    switch (locationType) {
      case "gastronomy":
        return "restaurants"
      case "ecommerce":
        return "shopping-basket"
      case "retail":
        return "sales"
      case "groceries":
        return "vegetables"
      case "premium_services":
        return "star"
      case "cluster":
        return "team"
    }
  }
}
